import { AdvancedImage } from "@cloudinary/react";
import React from "react";
import localeText from "../../../../locale";
import { formatPrice } from "../../../../utilities/formatPrice";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { useLocation } from "react-router-dom";

const ThankyouCard = ({ item, currencyFormat = {} }) => {
  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const image = isFringeBenefitsPage
    ? item.fringeBenefit.imageid1
    : item.productVariation && item.productVariation.imageid
    ? item.productVariation.imageid
    : item.product.imageid1;

  const getCurrency = () => {
    if (isFringeBenefitsPage) {
      return currencyFormat[item.fringeBenefit.currency] || item.fringeBenefit.currency;
    }
    return currencyFormat[item.product.currency] || item.product.currency;
  };

  const getPrice = () => {
    if (isFringeBenefitsPage) {
      return item.quantity * item.fringeBenefit.price;
    }
    return item.priceUnitary * item.quantity;
  };

  return (
    <div className="flex gap-3">
      <div style={{ height: "110px" }}>
        <AdvancedImage
          cldImg={cloudinaryInstance
            .image(image)
            .resize(fill().width(600).height(600))
            .format("webp")}
          height={110}
          className="h-100"
        />
      </div>
      <div className="flex flex-column">
        <div className="font-semibold" style={{ color: "#344563" }}>
          {isFringeBenefitsPage ? item.fringeBenefit.title : item.product.title}
        </div>
        <div className="flex gap-2 text-xs mt-2" style={{ color: "#7A869A" }}>
          <div>{localeText("quantity")}:</div>
          <div>{item.quantity}</div>
        </div>
        <div
          className="flex gap-2 align-items-end h-full font-bold mb-2"
          style={{ color: "#344563" }}
        >
          {getCurrency()} {formatPrice(getPrice())}
        </div>
      </div>
    </div>
  );
};

export default ThankyouCard;
